import IsNextYearEarlyRegistrationContext from "@/contexts/IsNextYearEarlyRegistrationContext";
import PackageContext from "@/contexts/PackageContext";
import { getLookupValueFromId } from '@/utils/lookupUtils';
import { faInfoCircle, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FormLookupsContext } from "@ngt/forms";
import { useScopedField } from "@ngt/forms-core";
import { DateTime } from "luxon";
import { FC, Fragment, useContext, useMemo } from "react";
import * as Dtos from '../../api/dtos';

const specialities = [
    "",
    "Medical Oncologist",
    "Surgeon / Surgical Oncologist",
    "Study Coordinator / Research Nurse",
    "Radiation Oncologist / Therapist",
    "Pathologist",
    "Statistician",
    "Breast Physician",
    "Nurse Counsellor",
    "Radiologist",
    "Endocrinologist",
    "Geneticist",
    "Haematologist",
    "Other",
    "Psycho-oncology / Quality of Life / Psychology",
    "Basic Scientist",
    "Consumer Advocacy",
    "BCT Staff",
    "General Practitioner",
    "Gynaecologist",
    "Pharmaceutical"
];

const RenderRegistrationCheck : FC = () => {
    const lookups = useContext(FormLookupsContext)
    const {state: {value: member}} = useScopedField<boolean>("membership", {value: true});
    const {state: {value: firstName}} = useScopedField<string>("firstName", {value: true});
    const {state: {value: lastName}} = useScopedField<string>("lastName", {value: true});
    const {state: {value: institution}} = useScopedField<string>("institution", {value: true});
    const {state: {value: speciality}} = useScopedField<string>("speciality", {value: true});
    const {state: {value: specialitySpec}} = useScopedField<string>("specialitySpec", {value: true});
    const {state: {value: address}} = useScopedField<string>("address", {value: true});
    const {state: {value: suburb}} = useScopedField<string>("suburb", {value: true});
    const {state: {value: postcode}} = useScopedField<string>("postcode", {value: true});
    const {state: {value: stateId}} = useScopedField<string>("state", {value: true});
    const {state: {value: country}} = useScopedField<string>("country", {value: true});
    const {state: {value: mobile}} = useScopedField<string>("mobile", {value: true});
    const {state: {value: email}} = useScopedField<string>("email", {value: true});

    const state = getLookupValueFromId(lookups, 'state', stateId);


    return(
        <Paper
            sx={{
                mt: { xs: 1, md: 3 }
            }}
        >
            <Table aria-label="simple table">
                <TableBody>
                    <TableRow>
                        <TableCell 
                            sx={{
                                pl: 4, 
                                verticalAlign: 'top',
                                width: {
                                    xs: '135px',
                                    md: '330px',
                                    lg: '420px'
                                }
                            }}
                        >
                            <strong>
                                Name
                            </strong>
                        </TableCell>
                        <TableCell 
                            sx={{
                                pr: 4, 
                                verticalAlign: 'top'
                            }}
                        >
                            { firstName + ' ' + lastName}
                        </TableCell>
                    </TableRow>
                    <TableRow
                        sx={{
                            backgroundColor: 'grey.50'
                        }}
                    >
                        <TableCell 
                            sx={{
                                pl: 4,
                                verticalAlign: 'top'
                            }}
                        >
                            <strong>
                                Member
                            </strong>
                        </TableCell>
                        <TableCell 
                            sx={{
                                pr: 4,
                                verticalAlign: 'top'
                            }}
                        >
                            {member ? 'Yes' : 'No'}
                        </TableCell>
                    </TableRow>
                    {
                        institution &&  (
                            <TableRow>
                                <TableCell 
                                    sx={{
                                        pl: 4,
                                        verticalAlign: 'top'
                                    }}
                                >
                                    <strong>
                                        Institution
                                    </strong>
                                </TableCell>
                                <TableCell 
                                    sx={{
                                        pr: 4,
                                        verticalAlign: 'top'
                                    }}
                                >
                                    {institution}
                                </TableCell>
                            </TableRow>
                        )
                    }
                    <TableRow
                        sx={{
                            backgroundColor: institution ? 'grey.50' : undefined
                        }}
                    >
                        <TableCell 
                            sx={{
                                pl: 4,
                                verticalAlign: 'top'
                            }}
                        >
                            <strong>
                                Speciality
                            </strong>
                        </TableCell>
                        <TableCell 
                            sx={{
                                pr: 4,
                                verticalAlign: 'top'
                            }}
                        >
                            {
                                speciality && parseInt(speciality) < 15 ? 
                                    specialities[parseInt(speciality)] : 
                                    "Other: " + (specialitySpec ?specialitySpec : "N/A")
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow
                        sx={{
                            backgroundColor: institution ? undefined : 'grey.50'
                        }}
                    >
                        <TableCell 
                            sx={{
                                pl: 4,
                                verticalAlign: 'top'
                            }}
                        >
                            <strong>
                                Address
                            </strong>
                        </TableCell>
                        <TableCell 
                            sx={{
                                pr: 4,
                                verticalAlign: 'top'
                            }}
                        >
                            {address}<br />
                            {suburb} {state} {postcode} <br />
                            {country}
                        </TableCell>
                    </TableRow>
                    <TableRow
                        sx={{
                            backgroundColor: institution ? 'grey.50' : undefined
                        }}
                    >
                        <TableCell 
                            sx={{
                                pl: 4,
                                verticalAlign: 'top'
                            }}
                        >
                            <strong>
                                Mobile Phone Number
                            </strong>
                        </TableCell>
                        <TableCell 
                            sx={{
                                pr: 4,
                                verticalAlign: 'top'
                            }}
                        >
                            {mobile}
                        </TableCell>
                    </TableRow>
                    <TableRow
                        sx={{
                            backgroundColor: institution ? undefined : 'grey.50'
                        }}
                    >
                        <TableCell 
                            sx={{
                                pl: 4, 
                                verticalAlign: 'top'
                            }}
                        >
                            <strong>
                                Email
                            </strong>
                        </TableCell>
                        <TableCell 
                            sx={{
                                pr: 4, 
                                verticalAlign: 'top'
                            }}
                        >
                            {email}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    )
}

const RenderPackageCheck : FC = () => {
    const {state: {value: regSessions}} = useScopedField<Dtos.RegistrationSession[]>("sessions", {value: true});
    const { package: packageData } = useContext(PackageContext)
    const dateToday = new Date();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const {state: {value: enteredDateStr}} = useScopedField<string>("enteredDate", {value: true});

    const {additionalSessions} = useContext(PackageContext);
    const isNextYearEarlyRegistration = useContext(IsNextYearEarlyRegistrationContext);

    const comparisonDate = useMemo(() => {
        if (enteredDateStr) {
            return DateTime.fromISO(enteredDateStr);
        }

        return dateToday;
    }, [enteredDateStr, dateToday])

    if (!packageData) {
        return null;
    }

    return(
        <>
            <Paper
                sx={{
                    mt: { xs: 1, md: 3 }
                }}
            >
                <Table aria-label="simple table">
                    <TableBody>
                        <TableRow>
                            <TableCell 
                                sx={{
                                    pl: 4, 
                                    verticalAlign: 'top',
                                    width: {
                                        xs: '135px',
                                        md: '330px',
                                        lg: '420px'
                                    }
                                }}
                            >
                                <strong>
                                    Package
                                </strong>
                            </TableCell>
                            <TableCell 
                                sx={{
                                    pr: 4, 
                                    verticalAlign: 'top'
                                }}
                            >
                                {packageData?.name}
                            </TableCell>
                        </TableRow>
                        <TableRow
                            sx={{
                                backgroundColor: 'grey.50'
                            }}
                        >
                            <TableCell 
                                sx={{
                                    pl: 4,
                                    verticalAlign: 'top'
                                }}
                            >
                                <strong>
                                    Description
                                </strong>
                            </TableCell>
                            <TableCell 
                                sx={{
                                    pr: 4,
                                    verticalAlign: 'top'
                                }}
                            >
                                {packageData?.description}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell 
                                sx={{
                                    pl: 4, 
                                    verticalAlign: 'top'
                                }}
                            >
                                <strong>
                                    Price
                                </strong>
                            </TableCell>
                            <TableCell 
                                sx={{
                                    pr: 4, 
                                    verticalAlign: 'top'
                                }}
                            >
                                ${packageData?.discountPrice ? packageData.discountPrice : packageData?.price}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
            <Typography variant='h4' color="secondary" mt={4}>Included Sessions</Typography>

            {isNextYearEarlyRegistration && (
                <Typography variant='body1' color="text.secondary" mt={2}>
                    Your registration includes a comprehensive package covering all three days of the program, access to sponsored symposiums, and attendance at the conference dinner.
                </Typography>
            )}

            {!isNextYearEarlyRegistration && (<>
            <Paper
                sx={{
                    mt: { xs: 1, md: 3 }
                }}
            >

                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell  
                                    sx={{
                                        pl: 4,
                                        width: {
                                            md: '330px',
                                            lg: '420px'
                                        }
                                    }}
                            >
                                <b>Name</b>
                            </TableCell>
                            {!isMobile && <TableCell sx={{pr: 4}}><b>Time</b></TableCell>}
                            <TableCell sx={{pr:4, width: {md: '100px', lg: '200px'}}}><b>Price</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            packageData.sessions?.filter(x => regSessions?.some(psession => psession.sessionId === x.id)).map((session: Dtos.Session, index) => {
                                const includedSession = regSessions?.find(x => x.sessionId === session.id);

                                return(                                    
                                    <Fragment
                                        key={session.id}
                                    >
                                        <TableRow
                                            sx={{
                                                backgroundColor: index % 2 == 0 ? undefined : 'grey.50'
                                            }}
                                        >
                                            <TableCell sx={{pl: 4}}>{session.name}</TableCell>
                                            {!isMobile && <TableCell>{!session.dateTimeOverride ? 'To Be Comfirmed' : session.dateTimeOverride}</TableCell>}
                                            <TableCell sx={{pr: 4}}></TableCell>
                                        </TableRow>
                                        {
                                            session.additionalAttendees && !!includedSession?.numberOfAttendees && (
                                                <TableRow
                                                    sx={{
                                                        backgroundColor: index % 2 == 0 ? undefined : 'grey.50'
                                                    }}
                                                >
                                                    <TableCell sx={{pl: 8}}>Additional Attendees {includedSession.numberOfAttendees}</TableCell>
                                                    {!isMobile && <TableCell></TableCell>}
                                                    <TableCell sx={{pr: 4}}>${includedSession.numberOfAttendees * (session.additionalPrice ?? 0)}</TableCell>
                                                </TableRow>
                                            )
                                        }

                                    </Fragment>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </Paper>
            
            <Typography variant='h4' color="secondary" mt={4}>Additional Sessions</Typography>
            {
                regSessions?.some(rs => !packageData!.sessions?.some(s => s.id === rs.sessionId)) ?
                <Paper
                    sx={{
                        mt: { xs: 1, md: 3 }
                    }}
                >
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell 
                                    sx={{
                                        pl: 4,
                                        width: {
                                            md: '330px',
                                            lg: '420px'
                                        }
                                    }}
                                >
                                    <b>Name</b>
                                </TableCell>
                                {!isMobile && <TableCell><b>Time</b></TableCell>}
                                <TableCell sx={{pr: 4, width: {md: '100px', lg: '200px'}}}><b>Price</b></TableCell>
                            </TableRow>
                        </TableHead>
                            <TableBody>
                            {
                                regSessions?.filter(x => !packageData.sessions?.some(session => session.id === x.sessionId)).map((additionalSession: Dtos.RegistrationSession, index) => {
                                    const session = additionalSessions!.find(x => x.id === additionalSession.sessionId);

                                    if (!session) {
                                        return null;
                                    }

                                    return(
                                        <Fragment
                                            key={session.id}
                                        >
                                            <TableRow
                                                sx={{
                                                    backgroundColor: index % 2 == 0 ? undefined : 'grey.50'
                                                }}
                                            >
                                                <TableCell sx={{pl: 4}}>{session.name}</TableCell>
                                                {!isMobile && <TableCell>{!session.dateTimeOverride ? 'To Be Comfirmed' : session.dateTimeOverride}</TableCell>}
                                                <TableCell sx={{pr: 4}}>${session.price ?? 0}</TableCell>
                                            </TableRow>

                                            {
                                                session.additionalAttendees && !!additionalSession.numberOfAttendees && (
                                                    <TableRow
                                                        sx={{
                                                            backgroundColor: index % 2 == 0 ? undefined : 'grey.50'
                                                        }}
                                                    >
                                                        <TableCell sx={{pl: 8}}>Additional Attendees {additionalSession.numberOfAttendees}</TableCell>
                                                        {!isMobile && <TableCell></TableCell>}
                                                        <TableCell sx={{pr: 4}}>${additionalSession.numberOfAttendees * (session.additionalPrice ?? 0)}</TableCell>
                                                    </TableRow>
                                                )
                                            }

                                        </Fragment>
                                    )
                                })
                            }
                        </TableBody>
                    </Table> 
                </Paper> :
                <Box mt={2}>
                    <Alert
                        icon={<FontAwesomeIcon icon={faInfoCircle} />}
                        severity="info"
                    >
                        No Additional sessions selected
                    </Alert>
                </Box>
            }
            </>)}
        </>
    )
}

export { RenderPackageCheck, RenderRegistrationCheck };

